import set from 'lodash.set';
import get from 'lodash.get';
export const getPartialState = (initialState, properties) => properties.reduce((acc, current) => {
    set(acc, current, get(initialState, current));
    return acc;
}, {});
export const compareStates = (currentState, storeState, properties, equal) => properties.some(prop => !equal(get(currentState, prop), get(storeState, prop)));
